import React, { Component } from "react";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { toODataString } from "@progress/kendo-data-query";
import axios from "axios";
import { CellRender, GridNoRecord } from "../../..../../Shared/GridComponents/CommonComponents";
import PageTitle from "../../Shared/Title";
import ColumnMenu from "../../Shared/GridComponents/ColumnMenu";
import { history, currencyFormatter, datetimeFormatter, successToastr, downloadExcel, getFileNameWithDate, dateFormatter } from "../../../HelperMethods";
import { KPICODE, LocalizationResource } from "../../Shared/AppConstants";
import { NumberCell, convertShiftDateTime, convertShiftDateTimeWithSeconds } from "../../ReusableComponents";
import { EXCEL_DOWNLOAD_INPROGRESS } from "../../Shared/AppMessages";
import { LocalizationHelper } from "../../../Localization/helpers/LocalizationHelper";

let initialDataState = {
    skip: 0,
    take: 10,
    filter: undefined,
};

export interface KPIDetailsProps {
    props: any;
    match: any;
    location: any;
    handleNo: any;
}

export interface KPIDetailsState {
    searchString: string;
    dataState?: any;
    data: any;
    total?: any;
    kpi?: string;
    kpiId: string;
    showLoader?: boolean;
    onFirstLoad?: boolean;
    kpiData?: any;
    excelData?: any;
    kpiCode?: any;
    filterType?: any;
}

export default class KPIDetails extends Component<KPIDetailsProps, KPIDetailsState> {
    public kpiDetailsFilters = {};
    constructor(props) {
        super(props);
        const { id } = this.props.match.params;
        const { filter } = this.props.match.params;
        const { kpicode } = this.props.match.params;
        this.state = {
            // filter: undefined,
            searchString: "",
            dataState: initialDataState,
            total: 0,
            kpiId: id,
            data: [],
            showLoader: true,
            onFirstLoad: true,
            kpiData: [],
            kpiCode: kpicode,
            filterType: filter
        };
    }

    componentDidMount() {
        this.customData();
        this.kpiDetailsFilters = JSON.parse(localStorage.getItem(`${"KPIDetails-GridDataState"}`));
        if (this.kpiDetailsFilters && Object.keys(this.kpiDetailsFilters).find((x) => x === this.state.kpiId)) {
            let dataState = this.kpiDetailsFilters[this.state.kpiId]
            this.setState({
                dataState: dataState
            }, () => this.getKpiDetails(dataState));
        } else {
            this.getKpiDetails(this.state.dataState);
        }
    }

    getKpiDetails = (dataState) => {
        var queryStr = `${toODataString(dataState)}`;
        axios.get(`api/home/kpi/${this.state.kpiId}/details?${`$count=true&`}${queryStr}&filterType=${this.state.filterType}&kpiCode=${this.state.kpiCode}`).then((res) => {
            this.setState({
                data: res.data.items,
                kpi: res.data.count > 0 ? res.data.items[0]?.kpi : "KPI Details",
                total: res.data.count,
                showLoader: false,
            });
        })
    }

    onDataStateChange = (changeEvent) => {
        this.setState({ dataState: changeEvent.dataState });
        this.getKpiDetails(changeEvent.dataState);
        if (this.kpiDetailsFilters && !Object.keys(this.kpiDetailsFilters).find((x) => x === this.state.kpiId)) {
            this.kpiDetailsFilters[this.state.kpiId] = changeEvent.dataState;
        }
        else {
            if (this.kpiDetailsFilters === null) this.kpiDetailsFilters = {};
            this.kpiDetailsFilters[this.state.kpiId] = changeEvent.dataState;
        }
        localStorage.setItem("KPIDetails-GridDataState", JSON.stringify(this.kpiDetailsFilters));
    };

    customData = () => {
        const kpiData = [{
            id: 'KPI Details',
            text: 'KPI Details',
            icon: '',
            pageUrl: undefined,
            disabled: false
        }];

        this.setState({ kpiData: [...kpiData] });
    }

    downloadKPIExcel = (dataState, fileName) => {
        var finalState = {
            ...dataState,
            take: null,
            skip: 0,
        };
        successToastr(EXCEL_DOWNLOAD_INPROGRESS);
        var queryStr = `${toODataString(finalState)}`;
        axios.get(`/api/home/kpi/${this.state.kpiId}/details/data?${queryStr}&filterType=${this.state.filterType}&kpiCode=${this.state.kpiCode}`).then((res: any) => {
            if (res) {
                downloadExcel(`${getFileNameWithDate(fileName)}.xlsx`, res.data);
            }
        });
    }

    render() {
        const { kpi, kpiCode } = this.state;
        return (
            <>
                <div className="col-11 mx-auto pl-0 pr-0">
                    <div className="container-fluid mb-3 remove-row px-0">
                        <div className="col-12 position-relative px-0">
                            <PageTitle
                                title="KPI Details"
                                isCustomBreadcrumb={true}
                                breadCrumbData={this.state.kpiData}
                            />
                            <span className="mr-2 float-right text-dark shadow invoice cursor-pointer excel-icon-wrap"
                                title="Excel"
                                onClick={() => this.downloadKPIExcel(this.state.dataState, kpi)} >
                                <FontAwesomeIcon icon={faFileExcel} style={{ color: "white" }} className={"faclock_size d-block"}></FontAwesomeIcon>
                            </span>
                        </div>
                    </div>

                    <div className="container-fluid">
                        <div className="row ml-0 mr-0 mt-2 mb-2 mt-lg-3 mb-lg-3">
                            <Grid
                                style={{ height: "auto" }}
                                sortable={true}
                                onDataStateChange={this.onDataStateChange}
                                pageable={{ pageSizes: true }}
                                data={this.state.data}
                                {...this.state.dataState}
                                total={this.state.total}
                                className="text-center kendo-grid-custom k-widget col-12 pl-0 pr-0 shadowchild font-weight-normal global-action-grid-onlyhead"
                            >
                                <GridNoRecords>{GridNoRecord(this.state.showLoader)}</GridNoRecords>
                                <GridColumn
                                    field="kpi"
                                    width="150px"
                                    title="KPI Name"
                                    columnMenu={ColumnMenu}
                                    cell={(props) => CellRender(props, "KPI Name")}
                                />
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION || kpiCode == KPICODE.CANDIDATECLEARANCE || kpiCode == KPICODE.TIMESHEETSTATUS || kpiCode == KPICODE.TOTALHOURS || kpiCode == KPICODE.TOTALACTIVEHOURSWORKED) &&
                                    <GridColumn
                                        field="reqNumber"
                                        width="130px"
                                        title="Req#"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Req#")}
                                    />
                                }
                                {(kpiCode == KPICODE.REMITTANCE || kpiCode == KPICODE.TOTALAPPROVEDHOURS || kpiCode == KPICODE.TOTALSPEND) &&
                                    <GridColumn
                                        field="clientInvoiceNumber"
                                        width="160px"
                                        title="CBI#"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "CBI#")}
                                    />
                                }
                                {(kpiCode == KPICODE.REMITTANCE || kpiCode == KPICODE.TOTALAPPROVEDHOURS || kpiCode == KPICODE.VENDORINVOICESTATUS || kpiCode == KPICODE.EMPLOYEESPEND) &&
                                    <GridColumn
                                        field="vendorInvoiceNumber"
                                        width="150px"
                                        title="Vendor Invoice #"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Vendor Invoice #")}
                                    />
                                }
                                {(kpiCode == KPICODE.PROVIDERHEADCOUNT || kpiCode == KPICODE.TIMESHEETSTATUS || kpiCode == KPICODE.TOTALHOURS || kpiCode == KPICODE.TOTALACTIVEHOURSWORKED) &&
                                    <GridColumn
                                        field="candidateName"
                                        width="120px"
                                        title="Provider"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Provider")}
                                    />
                                }
                                {(kpiCode == KPICODE.TIMESHEETSTATUS || kpiCode == KPICODE.TOTALHOURS || kpiCode == KPICODE.TOTALACTIVEHOURSWORKED) &&
                                    <GridColumn
                                        field="client"
                                        width="100px"
                                        title="Client"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Client")}
                                    />
                                }
                                {(kpiCode == KPICODE.CANDIDATECLEARANCE || kpiCode == KPICODE.TOTALAPPROVEDHOURS || kpiCode == KPICODE.PROVIDERHEADCOUNT || kpiCode == KPICODE.TIMESHEETSTATUS || kpiCode == KPICODE.TOTALHOURS || kpiCode == KPICODE.TOTALACTIVEHOURSWORKED || kpiCode == KPICODE.VENDORINVOICESTATUS || kpiCode == KPICODE.EMPLOYEESPEND) &&
                                    <GridColumn
                                        field="vendor"
                                        width="100px"
                                        title="Vendor"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Vendor")}
                                    />
                                }
                                {kpiCode == KPICODE.CANDIDATECLEARANCE &&
                                    <GridColumn
                                        field="candidateName"
                                        width="120px"
                                        title="Candidate Name"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Candidate Name")}
                                    />
                                }
                                {kpiCode == KPICODE.TOTALAPPROVEDHOURS &&
                                    <GridColumn
                                        field="candidateName"
                                        width="120px"
                                        title="Associate"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Associate")}
                                    />
                                }
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION || kpiCode == KPICODE.TOTALAPPROVEDHOURS || kpiCode == KPICODE.TIMESHEETSTATUS || kpiCode == KPICODE.TOTALHOURS || kpiCode == KPICODE.TOTALACTIVEHOURSWORKED) &&
                                    <GridColumn
                                        field="division"
                                        width="120px"
                                        title="Division"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Division")}
                                    />
                                }
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION || kpiCode == KPICODE.CANDIDATECLEARANCE || kpiCode == KPICODE.TOTALAPPROVEDHOURS || kpiCode == KPICODE.TIMESHEETSTATUS || kpiCode == KPICODE.TOTALHOURS || kpiCode == KPICODE.TOTALACTIVEHOURSWORKED || kpiCode == KPICODE.PROVIDERHEADCOUNT) &&
                                    <GridColumn
                                        field="location"
                                        width="120px"
                                        title={LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")}
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Location")}
                                    />
                                }
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION || kpiCode == KPICODE.CANDIDATECLEARANCE || kpiCode == KPICODE.TOTALAPPROVEDHOURS) &&
                                    <GridColumn
                                        field="position"
                                        width="120px"
                                        title="Position"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Position")}
                                    />
                                }
                                {kpiCode == KPICODE.TOTALAPPROVEDHOURS &&
                                    <GridColumn
                                        field="jobStartDate"
                                        width="110px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Job Start Date"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Job Start Date")}
                                    />
                                }
                                {kpiCode == KPICODE.TOTALAPPROVEDHOURS &&
                                    <GridColumn
                                        field="jobEndDate"
                                        width="110px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Job End Date"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Job End Date")}
                                    />
                                }
                                {kpiCode == KPICODE.TOTALAPPROVEDHOURS &&
                                    <GridColumn
                                        field="zone"
                                        width="90px"
                                        title="Zone"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Zone")}
                                    />
                                }
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION || kpiCode == KPICODE.TOTALAPPROVEDHOURS) &&
                                    <GridColumn
                                        field="region"
                                        width="90px"
                                        title="Region"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Region")}
                                    />
                                }
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION) &&
                                    <GridColumn
                                        field="hiringManager"
                                        width="120px"
                                        title="Hiring Manager"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Hiring Manager")}
                                    />
                                }
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION) &&
                                    <GridColumn
                                        field="required"
                                        width="80px"
                                        title="Required"
                                        filter="numeric"
                                        headerClassName="text-right pr-4"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => NumberCell(props, "Required")}
                                    />
                                }
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION) &&
                                    <GridColumn
                                        field="noOfFilledStaff"
                                        width="90px"
                                        title="Filled Rate"
                                        headerClassName="text-right pr-4"
                                        filter="text"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => NumberCell(props, "Filled Rate", true)}
                                    />
                                }
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION || kpiCode == KPICODE.TOTALHOURS || kpiCode == KPICODE.TOTALACTIVEHOURSWORKED) &&
                                    <GridColumn
                                        field="startDate"
                                        width="110px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Start Date"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Start Date")}
                                    />
                                }
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION || kpiCode == KPICODE.TOTALHOURS || kpiCode == KPICODE.TOTALACTIVEHOURSWORKED) &&
                                    <GridColumn
                                        field="endDate"
                                        width="110px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="End Date"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "End Date")}
                                    />
                                }
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION) &&
                                    <GridColumn
                                        field="shiftStartTime"
                                        width="110px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Shift Start Time"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Shift Start Time", null, true)}
                                    />
                                }
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION) &&
                                    <GridColumn
                                        field="shiftEndTime"
                                        width="110px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Shift End Time"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Shift End Time", null, true)}
                                    />
                                }
                                {(kpiCode == KPICODE.CANDIDATECLEARANCE || kpiCode == KPICODE.VENDORINVOICESTATUS) &&
                                    <GridColumn
                                        field="openDays"
                                        width="100px"
                                        title="Open Days"
                                        filter="numeric"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => NumberCell(props, "Open Days")}
                                    />
                                }
                                {(kpiCode == KPICODE.REMITTANCE || kpiCode == KPICODE.TOTALSPEND) &&
                                    <GridColumn
                                        field="cbiRunDate"
                                        width="160px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Run Date"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => {
                                            return (
                                                <td
                                                    contextMenu="Run Date"
                                                    title={props.dataItem.cbiRunDate ? `${dateFormatter(new Date(props.dataItem.cbiRunDate))} ${convertShiftDateTimeWithSeconds(props.dataItem.cbiRunDate)}` : "-"}
                                                >
                                                    {props.dataItem.cbiRunDate ? `${dateFormatter(new Date(props.dataItem.cbiRunDate))} ${convertShiftDateTimeWithSeconds(props.dataItem.cbiRunDate)}` : "-"}
                                                </td>
                                            )
                                        }}
                                    />
                                }
                                {(kpiCode == KPICODE.VENDORINVOICESTATUS || kpiCode == KPICODE.EMPLOYEESPEND) &&
                                    <GridColumn
                                        field="billingPeriodStartDate"
                                        width="110px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Billing Period Start Date"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Billing Period Start Date")}
                                    />
                                }
                                {(kpiCode == KPICODE.VENDORINVOICESTATUS || kpiCode == KPICODE.EMPLOYEESPEND) &&
                                    <GridColumn
                                        field="billingPeriodEndDate"
                                        width="110px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Billing Period End Date"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Billing Period End Date")}
                                    />
                                }
                                {(kpiCode == KPICODE.TOTALAPPROVEDHOURS || kpiCode == KPICODE.TIMESHEETSTATUS) &&
                                    <GridColumn
                                        field="payPeriodStartDate"
                                        width="110px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Pay Period Start Date"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Pay Period Start Date")}
                                    />
                                }
                                {(kpiCode == KPICODE.TOTALAPPROVEDHOURS || kpiCode == KPICODE.TIMESHEETSTATUS) &&
                                    <GridColumn
                                        field="payPeriodEndDate"
                                        width="110px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Pay Period End Date"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Pay Period End Date")}
                                    />
                                }
                                {(kpiCode == KPICODE.REMITTANCE || kpiCode == KPICODE.TOTALAPPROVEDHOURS || kpiCode == KPICODE.TOTALSPEND || kpiCode == KPICODE.TIMESHEETSTATUS || kpiCode == KPICODE.TOTALHOURS || kpiCode == KPICODE.TOTALACTIVEHOURSWORKED || kpiCode == KPICODE.VENDORINVOICESTATUS || kpiCode == KPICODE.EMPLOYEESPEND) &&
                                    <GridColumn
                                        field="hours"
                                        width="80px"
                                        title="Hours"
                                        headerClassName="text-right pr-4"
                                        cell={(props) =>
                                            props.dataItem.hours !== undefined &&
                                                props.dataItem.hours !== null &&
                                                props.dataItem.hours > 0 ? (
                                                <td
                                                    className="text-right pr-4"
                                                    contextMenu={"Hours"}
                                                    title={Number(props.dataItem.hours).toFixed(2)}
                                                >
                                                    {Number(props.dataItem.hours).toFixed(2)}
                                                </td>
                                            ) : (
                                                <td style={{ textAlign: "right" }}>{"-"}</td>
                                            )
                                        }
                                        filter="numeric"
                                        columnMenu={ColumnMenu}
                                    />
                                }
                                {(kpiCode == KPICODE.REMITTANCE || kpiCode == KPICODE.TOTALSPEND) &&
                                    <GridColumn
                                        field="amount"
                                        width="80px"
                                        title="Amount"
                                        filter="numeric"
                                        headerClassName="text-right pr-4"
                                        cell={(props) => {
                                            return (
                                                <td
                                                    contextMenu={"Amount"}
                                                    style={{ textAlign: "right" }}
                                                    title={currencyFormatter(props.dataItem.amount)}
                                                    className="pr-4"
                                                >
                                                    {currencyFormatter(props.dataItem.amount)}
                                                </td>
                                            );
                                        }}
                                        columnMenu={ColumnMenu}
                                    />
                                }
                                {(kpiCode == KPICODE.TIMESHEETSTATUS || kpiCode == KPICODE.VENDORINVOICESTATUS || kpiCode == KPICODE.EMPLOYEESPEND) &&
                                    <GridColumn
                                        field="billable"
                                        width="100px"
                                        title="Billable"
                                        filter="numeric"
                                        headerClassName="text-right pr-4"
                                        cell={(props) => {
                                            return (
                                                <td
                                                    contextMenu={"Billable"}
                                                    style={{ textAlign: "right" }}
                                                    title={currencyFormatter(props.dataItem.billable)}
                                                    className="pr-4"
                                                >
                                                    {currencyFormatter(props.dataItem.billable)}
                                                </td>
                                            );
                                        }}
                                        columnMenu={ColumnMenu}
                                    />
                                }
                                {kpiCode == KPICODE.TIMESHEETSTATUS &&
                                    <GridColumn
                                        field="submittedOn"
                                        width="110px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Submitted On"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Submitted On")}
                                    />
                                }
                                {kpiCode == KPICODE.PROVIDERHEADCOUNT &&
                                    <GridColumn
                                        field="jobTitle"
                                        width="120px"
                                        title="Job Title"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Job Title")}
                                    />
                                }
                                {kpiCode == KPICODE.VENDORINVOICESTATUS &&
                                    <GridColumn
                                        field="clientAuthorizedDate"
                                        width="160px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Client Authorized Date"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => {
                                            return (
                                                <td
                                                    contextMenu="Client Authorized Date"
                                                    title={props.dataItem.clientAuthorizedDate ? `${dateFormatter(new Date(props.dataItem.clientAuthorizedDate))} ${convertShiftDateTimeWithSeconds(props.dataItem.clientAuthorizedDate)}` : "-"}
                                                >
                                                    {props.dataItem.clientAuthorizedDate ? `${dateFormatter(new Date(props.dataItem.clientAuthorizedDate))} ${convertShiftDateTimeWithSeconds(props.dataItem.clientAuthorizedDate)}` : "-"}
                                                </td>
                                            )
                                        }}
                                    />
                                }
                                {kpiCode == KPICODE.VENDORINVOICESTATUS &&
                                    <GridColumn
                                        field="clientInvoiceNumber"
                                        width="160px"
                                        title="CBI#"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "CBI#")}
                                    />
                                }
                                {kpiCode == KPICODE.VENDORINVOICESTATUS &&
                                    <GridColumn
                                        field="cbiRunDate"
                                        width="160px"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Run Date"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => {
                                            return (
                                                <td
                                                    contextMenu="Run Date"
                                                    title={props.dataItem.cbiRunDate ? `${dateFormatter(new Date(props.dataItem.cbiRunDate))} ${convertShiftDateTimeWithSeconds(props.dataItem.cbiRunDate)}` : "-"}
                                                >
                                                    {props.dataItem.cbiRunDate ? `${dateFormatter(new Date(props.dataItem.cbiRunDate))} ${convertShiftDateTimeWithSeconds(props.dataItem.cbiRunDate)}` : "-"}
                                                </td>
                                            )
                                        }}
                                    />
                                }
                                {(kpiCode == KPICODE.OPENREQUISITION || kpiCode == KPICODE.REJECTEDREQUISITION || kpiCode == KPICODE.ONHOLDREQUISITION || kpiCode == KPICODE.FILLEDREQUISITION || kpiCode == KPICODE.CANDIDATECLEARANCE || kpiCode == KPICODE.REMITTANCE || kpiCode == KPICODE.TOTALSPEND || kpiCode == KPICODE.PROVIDERHEADCOUNT || kpiCode == KPICODE.TIMESHEETSTATUS || kpiCode == KPICODE.TOTALHOURS || kpiCode == KPICODE.TOTALACTIVEHOURSWORKED || kpiCode == KPICODE.VENDORINVOICESTATUS || kpiCode == KPICODE.EMPLOYEESPEND) &&
                                    <GridColumn
                                        field="status"
                                        width="150px"
                                        title="Status"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "Status")}
                                    />
                                }
                                {kpiCode == KPICODE.REMITTANCE &&
                                    <GridColumn
                                        field="viStatus"
                                        width="110px"
                                        title="VI Status"
                                        columnMenu={ColumnMenu}
                                        cell={(props) => CellRender(props, "VI Status")}
                                    />
                                }
                            </Grid>
                        </div>
                        <div className="row mb-2 mb-lg-4 ml-0 mr-0">
                            <div className="col-12 text-center text-right font-regular">
                                <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={() => history.goBack()}>
                                    <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} />
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}